import React from 'react'
import { Typography } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import { useAuth } from 'App/Auth'
import Dashboard, { DashboardCardItem } from 'shared/Dashboard'
import useStyle from 'shared/hooks/useStyle'

import { useLocationContext } from '../Location'
import mainDashboardWidgetMap from './mainDashboardWidgetMap'

import styles from './MainDashboard.style'

const MainDashboard = () => {
    const { t } = useTranslation()
    const classes = useStyle(styles)
    const userInfo = useAuth()

    const { location } = useLocationContext()

    return (
        <div css={classes.root}>
            <div css={classes.main}>
                <div css={classes.userLocationTitle}>
                    <Typography
                        variant="h1"
                        css={classes.userLocationText}
                    >
                        {t('WELCOME_IN_LOCATION', {
                            username: `${userInfo.user.firstName} ${userInfo.user.lastName}`,
                            location: `${location.locationName}`,
                        })}
                    </Typography>
                </div>
                <Dashboard
                    widgets={mainDashboardWidgetMap}
                    widgetComponent={DashboardCardItem}
                    customClasses={{ container: classes.dashboard }}
                />
            </div>
        </div>
    )
}

export default MainDashboard
